export default __webpack_public_path__ + "static/media/oxygen-yellow.8f97ea9c.svg";